/**
 * Typed page state and response mapping for the Inspection Series listing.
 *
 * Canonical source of truth for all InspectionSeries/Index adapter/hook/service files.
 * Shared listing primitives come from @hooks/listings — only series-specific
 * types are defined here.
 *
 * Behavioral rules enforced here (from the frozen contract):
 *  - Search lives on ListingQueryState.search (IP-15819), not on SeriesFilters.
 *  - Page sizes are [25, 50, 100, 250] — four options (task-01 inventory).
 *  - Filters are always visible per prop flags (no active/inactive toggle).
 *  - Legacy cache shape: { hiddenColumns, stateFilters, kendoSortSettings, page }.
 */
/** Protocol value sent/accepted for expiredSeries All (no end_date restriction). */
export const EXPIRED_SERIES_ALL_VALUE = 'all';
// ---------------------------------------------------------------------------
// Initial / default filter values
// ---------------------------------------------------------------------------
export const INITIAL_SERIES_FILTERS = {
    building: [],
    account: [],
    territory: [],
    expirationDate: { start: null, end: null, rangeType: null },
    status: null,
    autoExtend: null,
    expiredSeries: false
};
// ---------------------------------------------------------------------------
// Page sizes (4 options per task-01 inventory — Series differs from Inspections)
// ---------------------------------------------------------------------------
export const SERIES_PAGE_SIZES = [25, 50, 100, 250];
export const SERIES_DEFAULT_PAGE_SIZE = 25;
